/* istanbul ignore file */

// posthog-js is loaded via the snippet in views/index.ejs, which populates
// window.posthog with a queueing stub and async-loads the real client from
// PostHog's CDN. All calls in this module go through that global.

const SERVICE = 'funsoft';

interface IInitOptions {
  apiKey: string;
  apiHost: string;
  env: string;
  release: string;
}

let initialized = false;

function ph (): any {
  return (window as any).posthog;
}

export function initPostHog (options: IInitOptions) {
  if (!options.apiKey) { return; }
  if (!ph()) { return; }
  if (initialized) { return; }

  ph().init(options.apiKey, {
    api_host: options.apiHost || 'https://us.i.posthog.com',
    autocapture: false,
    defaults: '2026-01-30',
    loaded: (posthog: any) => {
      posthog.register({
        env: options.env,
        release: options.release,
        service: SERVICE,
      });
    },
    person_profiles: 'identified_only',
    session_recording: {
      maskAllInputs: true,
    },
    ui_host: 'https://us.posthog.com',
  });

  initialized = true;
}

export function identifyPostHog (userId: string | number, traits?: Record<string, unknown>) {
  if (!initialized) { return; }
  ph().identify(String(userId), traits);
}

export function trackPostHog (event: string, props?: Record<string, unknown>) {
  if (!initialized) { return; }
  ph().capture(event, props);
}

export function resetPostHog () {
  if (!initialized) { return; }
  ph().reset();
}
